import { render, staticRenderFns } from "./monitorInfo.vue?vue&type=template&id=2f6db2ff&scoped=true&"
import script from "./monitorInfo.vue?vue&type=script&lang=js&"
export * from "./monitorInfo.vue?vue&type=script&lang=js&"
import style0 from "./monitorInfo.vue?vue&type=style&index=0&id=2f6db2ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6db2ff",
  null
  
)

export default component.exports